import { render, staticRenderFns } from "./giveGiftsPop.vue?vue&type=template&id=74e0376e&scoped=true&"
import script from "./giveGiftsPop.vue?vue&type=script&lang=js&"
export * from "./giveGiftsPop.vue?vue&type=script&lang=js&"
import style0 from "./giveGiftsPop.vue?vue&type=style&index=0&id=74e0376e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e0376e",
  null
  
)

export default component.exports